import { styled } from '@mui/material/styles'
import React from 'react'
import {
  ArrayInput,
  FormDataConsumer,
  Labeled,
  SimpleFormIterator,
} from 'react-admin'
import { FormDataConsumerProps } from 'types/common'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import { computeQuantityByMaxParticipants } from '../common'
import { QuantityHintScopedFormDataType, WithQuantityHint } from '../types'
import { QuantityHintProps } from './DefaultQuantityHint'

const PREFIX = 'QuantityHintArrayInput'

const classes = {
  fieldsBox: `${PREFIX}-fieldsBox`,
  fieldWidth: `${PREFIX}-fieldWidth`,
  ml55: `${PREFIX}-ml55`,
}

const StyledArrayInput = styled(ArrayInput)(() => ({
  [`& .${classes.fieldsBox}`]: {
    display: 'flex',
    flexDirection: 'row',
    gap: '100px',
    width: '100%',
  },

  [`& .${classes.fieldWidth}`]: {
    width: '300px',
  },

  [`& .${classes.ml55}`]: {
    marginLeft: '50px',
  },
}))

const QuantityHintArrayInput: React.FC<QuantityHintProps> = ({
  guestsNumberMock,
  quantityHint,
}) => {
  return (
    <StyledArrayInput source="quantityHint">
      <SimpleFormIterator>
        <FormDataConsumer>
          {({
            scopedFormData,
            getSource,
          }: FormDataConsumerProps<
            WithQuantityHint,
            QuantityHintScopedFormDataType
          >) => (
            <div className={classes.fieldsBox}>
              <KNumberInput
                source={getSource!('maxParticipants')}
                label="form.fields.maxParticipants"
                type="number"
                className={classes.fieldWidth}
              />
              <KNumberInput
                source={getSource!('quantityMultiplier')}
                label="form.fields.quantityMultiplier"
                type="number"
                className={classes.fieldWidth}
                defaultValue={100}
              />
              <Labeled
                label="Simulated quantity"
                className={classes.fieldWidth}
              >
                <div>
                  {computeQuantityByMaxParticipants(
                    quantityHint,
                    scopedFormData?.maxParticipants,
                    scopedFormData?.quantityMultiplier,
                    guestsNumberMock
                  )}
                </div>
              </Labeled>
            </div>
          )}
        </FormDataConsumer>
      </SimpleFormIterator>
    </StyledArrayInput>
  )
}

export default QuantityHintArrayInput
